module.exports = __webpack_public_path__ + "img/banner-2.07ce72ee.png";